var map = {
	"./Machine1.svg": "af09",
	"./Machine2.svg": "ecfd",
	"./Machine3.svg": "5ae5",
	"./Machine4.svg": "b885",
	"./Machine5.svg": "b71b",
	"./Machine6.svg": "c3a4",
	"./Machine7.svg": "c8b5",
	"./Machine8.svg": "14d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f3b";